import React, { Component } from "react";
// import styles from "./CostOfLiving.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../Loader/Loader";
import axios from "axios";
import ConfirmModal from "./ConfirmModal";
import EditModal from "./EditModal";
import styles from "./DataBox.scss";
import classnames from "classnames";

export default class CostOfLiving extends Component {
  constructor(props) {
    super(props);
    this.state = {
      city_data: undefined,
      datum: undefined,
      data_schema: undefined,
      showConfirmModal: false,
      showEditModal: false
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  getNewDataSchema = () => {
    var data = { ...this.state.city_data[0] };
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (
        ent[0] === "_id" ||
        ent[0] === "transportation" ||
        ent[0] === "label" ||
        ent[0] === "value"
      ) {
        return null;
      } else if (typeof ent[1] === "string") {
        data_schema[ent[0]] = "";
        return null;
      } else if (typeof ent[1] === "boolean") {
        data_schema[ent[0]] = false;
        return null;
      } else if (typeof ent[1] === "number") {
        data_schema[ent[0]] = 0;
        return null;
      } else {
        data_schema[ent[0]] = "";
        return null;
      }
    });
    this.showEditModal(data_schema);
  };

  getDataSchema = data => {
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (
        ent[0] === "transportation" ||
        ent[0] === "label" ||
        ent[0] === "value"
      ) {
        return null;
      } else {
        data_schema[ent[0]] = ent[1];
      }
      return null;
    });
    this.showEditModal(data_schema);
  };

  updateTable = () => {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .get("/api/cityData/getalldata")
      .then(res => {
        this.setState({
          city_data: res.data
        });
      })
      .catch(e => console.log(e));
  };

  showConfirmModal = datum => {
    this.setState({ showConfirmModal: true, datum: datum });
  };

  hideConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  showEditModal = datum => {
    this.setState({ showEditModal: true, datum: datum });
  };

  hideEditModal = () => {
    this.setState({ showEditModal: false });
  };

  deleteData(datum, type) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/removecitydata", datum)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  updateOrAdd(datum, type) {
    const new_datum = { ...datum, value: datum["name"], label: datum["name"] };
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/updateoraddcitydata", new_datum)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  render() {
    if (!this.state.city_data) {
      return <Loader />;
    } else {
      return (
        <div className={styles.dataBox}>
          <ConfirmModal
            show={this.state.showConfirmModal}
            handleClose={this.hideConfirmModal}
            data={this.state.datum}
            deleteData={this.deleteData}
            updateTable={this.updateTable}
            type={this.state.type}
          />
          <EditModal
            show={this.state.showEditModal}
            handleClose={this.hideEditModal}
            data={this.state.datum}
            updateOrAdd={this.updateOrAdd}
            updateTable={this.updateTable}
            type={"City Data"}
          />
          <button
            className={classnames("btn btn-info", styles.modalButtons)}
            onClick={() => this.getNewDataSchema()}
          >
            <FontAwesomeIcon className={styles.cursor} icon={faPlus} />
          </button>
          <div
            className={classnames("table-responsive text-nowrap", styles.table)}
          >
            <table className="table table-striped w-auto">
              <thead>
                <tr>
                  <th scope="col"> Name</th>
                  <th scope="col"> Water </th>
                  <th scope="col">Heat </th>
                  <th scope="col"> Gasoline</th>
                  <th scope="col"> Property Taxes</th>
                  <th scope="col"> Rent</th>
                  <th scope="col"> Own</th>
                  <th scope="col"> Energy</th>
                  <th scope="col"> Groceries</th>
                  <th scope="col"> Public Transit</th>
                  <th scope="col"> Insurance</th>
                  <th scope="col"> Child Care</th>
                  <th scope="col"> Hidden</th>

                  <th scope="col">Edit</th>
                  <th scope="col">Delete</th>
                </tr>
              </thead>
              <tbody>
                {this.state.city_data.map((row, i) => {
                  return (
                    <tr key={i}>
                      <td>{row.name}</td>
                      <td>{row.water}</td>
                      <td>{row.heat}</td>
                      <td>{row.gasoline}</td>
                      <td>{row.property_taxes}</td>
                      <td>{row.rent}</td>
                      <td>{row.own}</td>
                      <td>{row.energy}</td>
                      <td>{row.groceries}</td>
                      <td>{row.public_transit}</td>
                      <td>{row.insurance}</td>
                      <td>{row.child_care}</td>
                      <td>{row.hidden.toString()}</td>

                      <td className="textCenter">
                        <FontAwesomeIcon
                          className={styles.cursor}
                          onClick={() => this.getDataSchema(row)}
                          style={{ color: "#323643" }}
                          icon={faEdit}
                        />
                      </td>
                      <td className="textCenter">
                        <FontAwesomeIcon
                          className={styles.cursor}
                          onClick={() => this.showConfirmModal(row)}
                          style={{ color: "#323643" }}
                          icon={faTrash}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/CostOfLiving.js